import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  styled,
} from "@mui/material";
import { useMemo } from "react";
import { getObjectDepth } from "src/utils/Utils";
import React from "react";

const StyledTableRowHead = styled(TableRow)(({ theme }) => ({
  "& td, & th": {
    border: 0,
    padding: theme.spacing(1, 1), // 12px top/bottom, 8px left/right
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "& td, & th": {
    border: 0,
    padding: theme.spacing(1.5, 1), // 12px top/bottom, 8px left/right
  },
}));

export const PlanComparisonTable = ({ sx, data }) => {
  const hasSubtitle = useMemo(
    () => getObjectDepth(data.body) === 3,
    [data.body]
  );

  const columnsWithTargets = useMemo(
    () => data.columns.filter((e) => Boolean(e.target)),
    [data.columns]
  );

  const renderCellContent = (content, isLastColumn = false) => {
    return (
      <Typography variant="subtitle2" fontWeight={isLastColumn ? 600 : "normal"}>
        {content}
      </Typography>
    );
  };

  return (
    <TableContainer sx={sx}>
      <Table>
        <TableHead>
          <StyledTableRowHead>
            {data.columns.map((column, index) => (
              <TableCell
                key={index}
                align={column.align ?? "left"}
                scope={column.scope ?? "auto"}
              >
                <Typography variant="h5" fontWeight={600}>
                  {column.label}
                </Typography>
              </TableCell>
            ))}
          </StyledTableRowHead>
        </TableHead>
        <TableBody>
          {Object.keys(data.body).map((title, index) => (
            <React.Fragment key={title}>
              {hasSubtitle ? (
                <>
                  <StyledTableRow key={title}>
                    <TableCell
                      component="th"
                      scope="row"
                      colSpan={data.columns.length}
                    >
                      <Typography
                        variant="subtitle2"
                        fontWeight={600}
                        letterSpacing={"0.4px"}
                        sx={{ color: "text.primary" }}
                      >
                        {title}
                      </Typography>
                    </TableCell>
                  </StyledTableRow>
                  {Object.keys(data.body[title]).map((subtitle) => (
                    <StyledTableRow key={`${title}-${subtitle}`}>
                      <TableCell component="th" scope="row">
                        <Typography variant="subtitle2">
                          {subtitle}
                        </Typography>
                      </TableCell>
                      {columnsWithTargets.map((column, columnIndex) => (
                        <TableCell key={columnIndex} align="center">
                          {renderCellContent(
                            data.body[title][subtitle][column.target],
                            columnIndex === columnsWithTargets.length - 1
                          )}
                        </TableCell>
                      ))}
                    </StyledTableRow>
                  ))}
                  {index !== Object.keys(data.body).length - 1 && (
                    <StyledTableRow key={`${title}-empty`}>
                      <TableCell colSpan={data.columns.length}>
                        &nbsp;
                      </TableCell>
                    </StyledTableRow>
                  )}
                </>
              ) : (
                <StyledTableRow>
                  <TableCell component="th" scope="row">
                    <Typography variant="subtitle2">{title}</Typography>
                  </TableCell>
                  {columnsWithTargets.map((column, index) => (
                    <TableCell key={index} align="center">
                      {renderCellContent(
                        data.body[title][column.target],
                        index === columnsWithTargets.length - 1
                      )}
                    </TableCell>
                  ))}
                </StyledTableRow>
              )}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
